import React from "react";
import { connect } from "react-redux";
import { Select } from "antd";

// Load JSON data instead of JS module
import enCountries from "localized-countries/data/en_US.json";

import localizedCountries from "localized-countries";

class SelectCountry extends React.Component {
  constructor(props) {
    super(props);

    // Ensure compatibility between server & browser
    this.state = {
      countries: localizedCountries(enCountries).array(),
    };
  }

  render() {
    // eslint-disable-next-line react/prop-types
    const { locale, ...props } = this.props;

    return (
      <Select
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
        {...props}
      >
        {this.state.countries.map((country) => (
          <Select.Option key={country.code} value={country.code}>
            {country.label}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

const mapState = (state) => ({
  locale: state.intl.locale,
});

const mapDispatch = {};

export default connect(mapState, mapDispatch)(SelectCountry);
